var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"mx-auto",staticStyle:{"background-color":"#fff"},attrs:{"color":"primary","outlined":"","align":"center","x-large":"","elevation":"5"},on:{"click":function($event){return _vm.reset()}}},[_vm._v(" Neu starten! ")])}
var staticRenderFns = []

export { render, staticRenderFns }